module.exports = __webpack_public_path__ + "static/holly_gibson_sq-0d056b2bd7b6b97078f5072faa5a49e8.jpg";